export default "/assets/517d8960e917e40a114fe22c2e0283c9.png";